import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("tfl_theme") || "light");

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark", "premium");
    if (theme === "dark") root.classList.add("dark");
    else if (theme === "premium") root.classList.add("premium");
    root.style.colorScheme = theme === "dark" ? "dark" : "light";
    localStorage.setItem("tfl_theme", theme);
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}
